export default class FoulingPolynomialsData {
    constructor(
        date,
        preds,
        predsLinear,
        time,
        vesselid,
        method,
        period
    ) {
        this.date = date;
        this.preds = preds;
        this.predsLinear = predsLinear;
        this.time = time;
        this.vesselid = vesselid;
        this.method = method;
        this.period = period;
    }

    get dateTimeStamp() {
        return new Date(this.date).getTime();
    }


}
